// @flow
import Input from '~/components/widgets/input/';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import { Button } from '~/components/widgets/buttons';

export const Wrapper = styled.div`
    align-items: center;
    border-bottom: ${({ theme }) => `1px solid ${theme.lightGrey}`};
    display: flex;
    padding: 1rem 0;
`;

export const DeviceIconWrapper = styled.div`
    align-items: center;
    background-color: ${({ theme }) => theme.mainBrandColor};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    min-height: 4.25rem;
    min-width: 4.25rem;
    position: relative;
`;

export const StyledSVGIcon = styled(SVGIcon)`
    height: 3em;
    width: 3em;
    > g {
        fill: ${({ theme }) => theme.white};
    }
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    margin-left: 1rem;
    width: 100%;
`;

export const InputStyled = styled(Input)`
    border: ${({ theme }) => `1px solid ${theme.mediumGrey} !important`};
    color: ${({ theme }) => theme.grey};
    font-size: 1.2rem;
    font-weight: 500;
`;

export const StatusContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
`;

export const Status = styled.span`
    color: ${({ theme }) => theme.linkColor};
    font-size: 1rem;
`;

export const IdentifyButton = styled(Button)`
    margin-left: 1em;
    height: 1.8em;
    padding: 0 1.8em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/item/styles.js